// Long-press for touch and pen. Safari on iPhone and iPad never sends contextmenu for a
// long-press (Chrome on Android and ChromeOS do), so a menu that only listens for contextmenu has
// no way in there. Pointer events, not touch events, so a convertible Chromebook in laptop mode
// still gets it from the screen. A mouse never triggers it; moving more than 10px cancels it.
export function longPress(el, fn, ms = 500) {
	let t = 0, x = 0, y = 0;
	const cancel = () => { clearTimeout(t); t = 0; };
	el.addEventListener("pointerdown", (e) => {
		if (e.pointerType === "mouse") return;
		x = e.clientX; y = e.clientY;
		cancel();
		t = setTimeout(() => { t = 0; fn(x, y); }, ms);
	});
	el.addEventListener("pointermove", (e) => { if (t && Math.hypot(e.clientX - x, e.clientY - y) > 10) cancel(); });
	for (const ev of ["pointerup", "pointercancel", "pointerleave"]) el.addEventListener(ev, cancel);
	return cancel;
}
